import { useWorkspaceChrome } from '@/components/linear/workspace-chrome';
import { Plus } from 'lucide-react';
import type { ReactNode } from 'react';

interface Props {
  title?: string;
  tabs?: ReactNode;
  actions?: ReactNode;
  showNew?: boolean;
}

export default function PageToolbar({ title, tabs, actions, showNew = true }: Props) {
  const { setCreateIssueOpen } = useWorkspaceChrome();

  return (
    <header className="ln-toolbar">
      {title ? <div className="ln-toolbar-title">{title}</div> : null}
      {tabs}
      <div className="ln-toolbar-spacer" />
      {actions}
      {showNew ? (
        <button
          type="button"
          className="ln-toolbar-plus"
          aria-label="New issue"
          onClick={() => setCreateIssueOpen(true)}
        >
          <Plus size={14} />
        </button>
      ) : null}
    </header>
  );
}
